// extracted by mini-css-extract-plugin
module.exports = {"definitionWord":"DictionaryBox_definitionWord__1lPt2","definitionTooltip":"DictionaryBox_definitionTooltip__RqbXq"};